import React from "react";
import { Award, Handshake, ShieldCheck, Users } from "lucide-react";

const LUIGI_PHOTO = "https://customer-assets-0z36b82j.emergentagent.net/job_cmc-auto-altamura/artifacts/erwb6jew_team_portrait_final_3.jpeg";
const ELENA_PHOTO = "https://customer-assets-0z36b82j.emergentagent.net/job_cmc-auto-altamura/artifacts/midk7ohi_team_woman_face2_white_shirt_4.jpeg";

const TeamCard = ({ photo, name, role, desc, tags }) => (
  <div className="bg-[#121214] border border-white/10 rounded-lg p-6 md:p-8 text-center hover:border-[#E1BC56]/40 transition">
    <div className="w-24 h-24 mx-auto mb-4 rounded-full overflow-hidden border-2 border-[#E1BC56]/40">
      <img src={photo} alt={name} className="w-full h-full object-cover object-top" />
    </div>
    <div className="text-[10px] tracking-widest text-[#E1BC56] font-display mb-1.5">{role}</div>
    <h3 className="font-display text-lg md:text-xl font-extrabold text-white tracking-wider mb-2 uppercase">{name}</h3>
    <p className="text-zinc-400 leading-relaxed text-sm mb-3">{desc}</p>
    <div className="flex flex-wrap gap-2 justify-center">
      {tags.map((t) => (
        <span key={t} className="border border-[#E1BC56]/30 px-2 py-0.5 rounded-sm text-[9px] tracking-widest uppercase font-display text-zinc-300">{t}</span>
      ))}
    </div>
  </div>
);

const Azienda = () => (
  <div>
    <section className="relative h-[50vh] overflow-hidden">
      <img src="https://images.unsplash.com/photo-1518987048-93e29699e79a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920" className="w-full h-full object-cover opacity-50" alt="Showroom LC Auto" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0B0B0C]/50 via-[#0B0B0C]/70 to-[#0B0B0C]" />
      <div className="absolute inset-0 flex items-center justify-center text-center px-6">
        <div>
          <div className="text-xs tracking-[0.4em] text-[#E1BC56] font-display mb-3">ALTAMURA (BA)</div>
          <h1 className="font-display text-4xl md:text-6xl font-extrabold text-white tracking-widest">L&apos;AZIENDA</h1>
          <p className="text-zinc-300 mt-4 max-w-2xl mx-auto">Passione per l&apos;automotive, cura del cliente, selezione ossessiva della qualit&agrave;.</p>
        </div>
      </div>
    </section>

    <section className="max-w-4xl mx-auto px-6 py-16">
      <div className="text-xs tracking-[0.4em] text-[#E1BC56] font-display mb-3">CHI SIAMO</div>
      <h2 className="font-display text-3xl md:text-4xl font-extrabold text-white tracking-widest mb-6">LC AUTO</h2>
      <div className="text-zinc-300 leading-relaxed space-y-4">
        <p>LC Auto nasce dalla passione di <strong className="text-[#E1BC56]">Luigi Cornacchia</strong> per il mondo automotive. Trattiamo ogni tipologia di auto &mdash; utilitarie, SUV, berline e sportive &mdash; con i massimi standard qualitativi: ogni veicolo &egrave; controllato nello storico, nelle manutenzioni e nelle condizioni prima di essere proposto ai nostri clienti.</p>
        <p>La nostra sede si trova ad <strong>Altamura (BA)</strong>, cuore della Puglia, ma serviamo clienti in tutta Italia con consegna dedicata su <strong>bisarca aperta</strong>. Ogni veicolo &egrave; accompagnato da garanzia, documentazione completa e piena trasparenza.</p>
        <p>Trattiamo <strong className="text-[#E1BC56]">permute</strong>, <strong className="text-[#E1BC56]">valutazioni gratuite</strong>, <strong className="text-[#E1BC56]">finanziamenti personalizzati</strong> e <strong className="text-[#E1BC56]">noleggio a lungo termine</strong> grazie a partner bancari affidabili.</p>
      </div>
    </section>

    {/* TEAM */}
    <section className="max-w-5xl mx-auto px-6 pb-20" data-testid="team-section">
      <div className="text-center mb-10">
        <div className="text-xs tracking-[0.4em] text-[#E1BC56] font-display mb-3">IL NOSTRO TEAM</div>
        <h2 className="font-display text-3xl md:text-5xl font-extrabold text-white tracking-wider mb-3">LE PERSONE DIETRO L&apos;INSEGNA.</h2>
        <p className="text-zinc-400 max-w-2xl mx-auto text-sm md:text-base">Ci mettiamo la faccia: ti seguiamo dalla scelta dell&apos;auto fino alle pratiche e oltre.</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-3xl mx-auto">
        <TeamCard
          photo={LUIGI_PHOTO}
          name="Luigi Cornacchia"
          role="TITOLARE & FONDATORE"
          desc="Da sempre appassionato di motori, segue personalmente ogni cliente dalla prima chiamata alla consegna, garantendo trasparenza e supporto costante."
          tags={["Referente Unico", "Consulenza"]}
        />
        <TeamCard
          photo={ELENA_PHOTO}
          name="Elena Manicone"
          role="AMMINISTRAZIONE & SOCIAL"
          desc="Cura l'amministrazione, le pratiche di vendita e la comunicazione social di LC Auto, con occhio attento ai dettagli e ai contenuti."
          tags={["Amministrazione", "Content & Social"]}
        />
      </div>
    </section>

    <section className="max-w-7xl mx-auto px-6 pb-20 grid grid-cols-1 md:grid-cols-4 gap-6">
      {[
        { icon: Award, title: "SELEZIONE", desc: "Solo veicoli controllati e certificati." },
        { icon: ShieldCheck, title: "GARANZIA", desc: "Copertura estesa su ogni auto venduta." },
        { icon: Users, title: "CONSULENZA", desc: "Un referente dedicato dalla A alla Z." },
        { icon: Handshake, title: "FINANZIAMENTI", desc: "Rate personalizzate con partner bancari." },
      ].map((p) => (
        <div key={p.title} className="bg-[#121214] border border-white/10 rounded-lg p-6 text-center hover:border-[#E1BC56]/40 transition">
          <p.icon className="w-10 h-10 mx-auto text-[#E1BC56] mb-4" strokeWidth={1.4} />
          <div className="font-display text-sm font-bold tracking-widest text-white mb-2">{p.title}</div>
          <div className="text-sm text-zinc-400">{p.desc}</div>
        </div>
      ))}
    </section>
  </div>
);

export default Azienda;
